module.exports = __webpack_public_path__ + "media/images/admin/favicons/android-chrome-192x192-b00865392c191eacfb0c811becd776db.png";